import type { OptionsIfc } from './common';

// 对齐接口，这里使用字符串
export enum GoodsAgeEnum {
  Child = '1',
  Adult = '2',
  Elderly = '3',
}

export const GoodsAgeRangeList: OptionsIfc<string>[] = [
  { label: 'pages-pool-member.goods.saleRange.child', value: GoodsAgeEnum.Child },
  { label: 'pages-pool-member.goods.saleRange.adult', value: GoodsAgeEnum.Adult },
  { label: 'pages-pool-member.goods.saleRange.elderly', value: GoodsAgeEnum.Elderly },
];

export enum GoodsStatusEnum {
  OffShelf = 0,
  OnShelf = 1,
}

export const GoodsStatusList: OptionsIfc<number>[] = [
  { label: 'pages-pool-member.goods.goodsStatus.onself', value: GoodsStatusEnum.OnShelf },
  { label: 'pages-pool-member.goods.goodsStatus.offself', value: GoodsStatusEnum.OffShelf },
];

export enum GoodsTypeEnum {
  Single = 1,
  Multiple = 21,
  Circle = 2,
  Compo = 3,
}

export const GoodsTypeList: OptionsIfc<number>[] = [
  { label: 'pages-pool-member.goods.goodsType.single', value: GoodsTypeEnum.Single },
  { label: 'pages-pool-member.goods.goodsType.multiple', value: GoodsTypeEnum.Multiple },
  { label: 'pages-pool-member.goods.goodsType.circle', value: GoodsTypeEnum.Circle },
  { label: 'pages-pool-member.goods.goodsType.groupTeam', value: GoodsTypeEnum.Compo },
];

export enum GoodsDayTypeEnum {
  Worker = 1,
  Holiday = 2,
}

export enum GoodsVerifyWayEnum {
  Code = 1,
  Face = 2,
  Manul = 4,
}
